module.exports = __webpack_public_path__ + "static/media/anage-lojas.5c31f258.webp";